import { useUser } from "@/stores/auth";
import { useProjects } from "@/stores/database";
import { Stack } from "@mantine/core";
import { AuthoritativeSources, DidYouKnow, Partners, RecentWork, Statistics, WhatOthersAreDoing } from ".";

export function DiscoverPageContent() {
  const user = useUser();
  const projects = useProjects();

  return (
    <Stack gap={80} flex={1} w="100%" maw={900}>
      <AuthoritativeSources />
      <Partners />
      <DidYouKnow />
      <WhatOthersAreDoing />
      <Statistics />
      {user && <RecentWork projects={projects} />}
    </Stack>
  );
}

